import * as Devices from 'expo-device';
import { Dimensions, Platform } from 'react-native';

type Client =
  | 'ios-native'
  | 'ios-rn'
  | 'ios-safari'
  | 'ipad-safari'
  | 'android-native'
  | 'android-rn'
  | 'android-chrome'
  | 'mac-safari'
  | 'mac-chrome'
  | 'mac-edge'
  | 'windows-safari'
  | 'windows-chrome'
  | 'windows-edge'
  | 'others';

export const isWeb = Platform.OS === 'web';

export const height = Dimensions.get('window').height;
export const width = Dimensions.get('window').width;

const isIpad = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return (
    ua.indexOf('ipad') > -1 ||
    (ua.indexOf('macintosh') > -1 && 'ontouchend' in document)
  );
};

const getOperaSystem = () => {
  const os = Devices.osName?.toLowerCase();
  if (os === 'ios') {
    return isIpad() ? 'ipad' : 'ios';
  } else if (os === 'mac os') {
    return isIpad() ? 'ipad' : 'mac';
  } else if (os === 'android') {
    return 'android';
  } else if (os === 'windows') {
    return 'windows';
  }
  return 'others';
};

const getBrowserType = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('edg') > -1) {
    return 'edge';
  } else if (ua.indexOf('chrome') > -1) {
    return 'chrome';
  } else if (ua.indexOf('safari') > -1) {
    return 'safari';
  } else {
    return 'others';
  }
};

const deviceInfo = {
  get client() {
    if (
      isWeb &&
      getOperaSystem() !== 'others' &&
      getBrowserType() !== 'others'
    ) {
      return `${getOperaSystem()}-${getBrowserType()}` as Client;
    } else if (Platform.OS === 'ios') {
      return 'ios-rn';
    } else if (Platform.OS === 'android') {
      return 'android-rn';
    } else {
      return 'others';
    }
  },
};

export default deviceInfo;
